import { UserGoalsData } from "../../types"
import { getGradeLevelIconName } from "../../../mp-utils/generic-utils"
import { getCategoryColors } from "../../../mp-core/themes/categoryColors"

export const statusHeadings = (args: {
  availableGoals: UserGoalsData[]
  averageScore: number
  program: string
  course: {
    name: string
    category?: string
  }
  isFinishingScore?: boolean
}) => {
  const { availableGoals, averageScore, program, course, isFinishingScore } =
    args

  if (
    !isFinishingScore &&
    (averageScore === null || averageScore === undefined)
  ) {
    return null
  }

  const averageScoreValue = Number(averageScore)

  // Find the goal for the specific program and subject
  const goal = availableGoals.find(
    goal => goal.test === program && goal.subtest === course.name
  )

  if (!goal || !goal.settings?.length) {
    return null
  }

  // Find the setting where averageScore falls within min-max range
  const matchingIndex = goal.settings.findIndex(
    (setting, _index, settingsArr) => {
      if (isFinishingScore && !averageScoreValue) {
        return !settingsArr.find(item => Number(item.min) < Number(setting.min))
      }

      const min = Number(setting.min)
      const max = Number(setting.max)

      return averageScoreValue >= min && averageScoreValue <= max
    }
  )

  if (matchingIndex === -1) {
    return null
  }

  const icon = getGradeLevelIconName(matchingIndex, goal.settings.length)

  return {
    icon,
    value: goal.settings[matchingIndex].name,
    categoryColor: getCategoryColors(course.category).secondary
  }
}
